(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deepcast-mobile-360"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('deepcast-rotate')) {
  class DeepcastRotate extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized=true;
      this.viewer=this.querySelector('model-viewer');
      this.stage=this.querySelector('.dc360__stage');
      this.fade=this.querySelector('.dc360__fade');
      this.hint=this.querySelector('.dc360__hint');
      this.tools=this.querySelector('.dc360__tools');
      this.swatches=[...this.querySelectorAll('[data-color]')];
      this.active=true;this.points=new Map();this.pitch=0;this.yaw=0;this.fov=30;this.color='Blue Current';this.sequence=0;
      this.mobile=matchMedia('(max-width:749px)');
      this.swatches.forEach(b=>b.addEventListener('click',()=>this.choose(b)));
      this.tools.addEventListener('click',e=>{const b=e.target.closest('[data-action]');if(!b)return;if(b.dataset.action==='reset'){this.pitch=0;this.yaw=0;this.fov=30;}else this.fov=Math.max(18,Math.min(44,this.fov+(b.dataset.action==='in'?-3:3)));this.renderPose();});
      this.viewer.addEventListener('load',()=>{this.ready=true;this.tools.hidden=false;clearTimeout(this.loadTimer);this.setAttribute('data-ready','');this.hint.textContent=this.active?this.dataset.hint:this.initialHint;this.viewer.variantName=this.color;});
      this.viewer.addEventListener('error',()=>this.fail());
      this.initialHint=this.hint.textContent;
      this.viewer.addEventListener('pointerdown',e=>this.down(e));
      this.viewer.addEventListener('pointermove',e=>this.move(e));
      ['pointerup','pointercancel','lostpointercapture'].forEach(type=>this.viewer.addEventListener(type,e=>{this.points.delete(e.pointerId);this.distance=null;}));
      this.viewer.addEventListener('keydown',e=>{if(!this.active)return;let handled=true;if(e.key==='ArrowLeft')this.yaw-=15;else if(e.key==='ArrowRight')this.yaw+=15;else if(e.key==='ArrowUp')this.pitch-=15;else if(e.key==='ArrowDown')this.pitch+=15;else if(e.key==='+'||e.key==='=')this.fov=Math.max(18,this.fov-3);else if(e.key==='-')this.fov=Math.min(44,this.fov+3);else if(e.key==='Home'){this.pitch=0;this.yaw=0;this.fov=30;}else if(e.key==='Escape')this.viewer.blur();else handled=false;if(handled){e.preventDefault();this.renderPose();}});
      this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&this.mobile.matches)this.load();},{rootMargin:'160px'});this.observer.observe(this);
      this.onResize=()=>{this.points.clear();if(this.mobile.matches&&this.getBoundingClientRect().top<innerHeight+160)this.load();};this.mobile.addEventListener('change',this.onResize);
      if(this.swatches[0])this.updateSelection(this.swatches[0]);
    }
    async load() {
      if(this.started||!this.mobile.matches)return;
      this.started=true;this.hint.textContent=this.dataset.loading;
      this.loadTimer=setTimeout(()=>{if(!this.ready)this.fail();},25000);
      try {
        if(!customElements.get('model-viewer')) {
          if(!window.deepcastModelViewerReady)window.deepcastModelViewerReady=new Promise((resolve,reject)=>{
            if(window.Shopify&&Shopify.loadFeatures){Shopify.loadFeatures([{name:'model-viewer',version:'1.12',onLoad:error=>error?reject(error):resolve()}]);}
            else reject(new Error('Viewer loader unavailable'));
          });
          await window.deepcastModelViewerReady;
          await customElements.whenDefined('model-viewer');
        }
        this.viewer.src=this.dataset.model;

      } catch(error) {this.fail();}
    }
    fail(){this.ready=false;this.points.clear();this.tools.hidden=true;this.hint.textContent=this.dataset.error;this.removeAttribute('data-ready');}
    down(e){if(!this.active||!this.ready)return;e.preventDefault();this.viewer.setPointerCapture(e.pointerId);this.points.set(e.pointerId,{x:e.clientX,y:e.clientY});this.distance=null;}
    move(e){if(!this.points.has(e.pointerId))return;e.preventDefault();const old=this.points.get(e.pointerId);this.points.set(e.pointerId,{x:e.clientX,y:e.clientY});if(this.points.size===1){this.yaw+=(e.clientX-old.x)*.65;this.pitch+=(e.clientY-old.y)*.65;}else{const [a,b]=[...this.points.values()];const d=Math.hypot(a.x-b.x,a.y-b.y);if(this.distance&&d>0)this.fov=Math.max(18,Math.min(44,this.fov*this.distance/d));this.distance=d;}this.renderPose();}
    renderPose(){if(this.poseFrame)return;this.poseFrame=requestAnimationFrame(()=>{this.viewer.orientation=`0deg ${this.pitch}deg ${this.yaw}deg`;this.viewer.fieldOfView=`${this.fov}deg`;this.poseFrame=null;});}
    updateSelection(button){this.color=button.dataset.color;this.swatches.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelector('.dc360__color-name').textContent=this.color;const cta=this.querySelector('.dc360__cta');if(!cta)return;cta.href=`${this.dataset.product}?variant=${encodeURIComponent(button.dataset.variant)}`;cta.querySelector('span').textContent=this.color;}
    async choose(button){const previous=this.color;this.updateSelection(button);if(!this.ready||previous===this.color)return;const seq=++this.sequence;clearTimeout(this.fadeTimer);if(!matchMedia('(prefers-reduced-motion:reduce)').matches){try{this.fade.src=this.viewer.toDataURL('image/png');this.fade.hidden=false;this.fade.style.opacity='1';}catch(error){this.fade.hidden=true;}}this.viewer.variantName=this.color;await this.viewer.updateComplete;requestAnimationFrame(()=>requestAnimationFrame(()=>{if(seq!==this.sequence)return;this.fade.style.opacity='0';this.fadeTimer=setTimeout(()=>{if(seq===this.sequence)this.fade.hidden=true;},350);}));}
    disconnectedCallback(){this.observer?.disconnect();this.mobile?.removeEventListener('change',this.onResize);clearTimeout(this.loadTimer);clearTimeout(this.fadeTimer);cancelAnimationFrame(this.poseFrame);}
  }
  customElements.define('deepcast-rotate',DeepcastRotate);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deepcast-mobile-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('deepcast-mobile')){
customElements.define('deepcast-mobile',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.addEventListener('change',event=>{if(event.target.matches('input[name="id"]'))this.select(event.target.value)});
const initial=this.querySelector('input[name="id"]:checked');if(initial)this.select(initial.value);
}
select(id){
const slides=[...this.querySelectorAll('.dc-slide')];const active=slides.find(slide=>slide.dataset.id===id);if(!active)return;
slides.forEach(slide=>slide.hidden=slide!==active);
this.querySelector('[data-price-output]').textContent=active.dataset.price;
this.querySelector('[data-spec-output]').textContent=active.dataset.spec?active.dataset.spec+' / ':'';
const available=active.dataset.available==='true';this.querySelector('.dc-buy').disabled=!available;
this.querySelector('[data-button-label]').textContent=available?this.dataset.add:this.dataset.sold;
this.querySelector('[data-button-price]').textContent=available?' — '+active.dataset.price:'';
this.querySelector('[data-details]').href=active.dataset.url;
}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deepcast-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deepcast-reviews')) {
    customElements.define('deepcast-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.dc-reviews__track');
        this.cards = [...this.querySelectorAll('.dc-reviews__card')];
        if (!this.cards.length) return;
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.querySelector('.dc-reviews__controls').hidden = false;
        const move = direction => {
          const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
          this.track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.previous.addEventListener('click', () => move(-1), {signal});
        this.next.addEventListener('click', () => move(1), {signal});
        this.track.addEventListener('scroll', () => this.update(), {signal, passive:true});
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      update() {
        const left = this.track.scrollLeft;
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.querySelector('[data-position]').textContent = Math.min(this.cards.length, Math.round(left / step) + 1);
        this.previous.disabled = left <= 2;
        this.next.disabled = left >= maximum - 2;
      }
      disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.controller=null;}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
